import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubdomainService {
  getSubdomain = () => {
    if (window.location.host == 'localhost:4200' || window.location.host == '192.168.0.53:4200') {
      return 'bailorup';
    } else {
      let [subdomain] = window.location.host.split('.');
      return subdomain;
    }
  };
}
